import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { tanimlarApi } from '../services/api';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const hdr = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
const YIL = new Date().getFullYear();
const AY  = new Date().getMonth() + 1;
const AYLAR = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

function fmt(val: any, suffix = '') {
  if (val === null || val === undefined || val === 0) return '—';
  return Number(val).toLocaleString('tr-TR') + (suffix ? ' ' + suffix : '');
}

interface KartProps {
  baslik: string; ikon: string; renk: string;
  satirlar: { etiket: string; deger: string }[];
  yukleniyor: boolean; veriYok: boolean; route: string;
}

function Kart({ baslik, ikon, renk, satirlar, yukleniyor, veriYok, route }: KartProps) {
  const navigate = useNavigate();
  return (
    <div onClick={() => navigate(route)} style={{
      border: `2px solid ${renk}22`, borderRadius: 10, padding: '14px 16px',
      cursor: 'pointer', transition: 'all .15s', background: '#fff',
      boxShadow: '0 1px 4px rgba(0,0,0,.06)',
    }}
      onMouseEnter={e => (e.currentTarget.style.boxShadow = `0 4px 16px ${renk}33`)}
      onMouseLeave={e => (e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,.06)')}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
        <span style={{ fontSize: 22 }}>{ikon}</span>
        <span style={{ fontWeight: 700, fontSize: 13, color: renk }}>{baslik}</span>
        <span style={{ marginLeft: 'auto', fontSize: 10, color: '#bbb' }}>→ Detay</span>
      </div>
      {yukleniyor ? (
        <div style={{ color: '#bbb', fontSize: 12, textAlign: 'center', padding: '8px 0' }}>Yükleniyor...</div>
      ) : veriYok ? (
        <div style={{ color: '#ccc', fontSize: 12, textAlign: 'center', padding: '8px 0' }}>Veri girilmemiş</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {satirlar.map(s => (
            <div key={s.etiket} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
              <span style={{ color: '#777' }}>{s.etiket}</span>
              <span style={{ fontWeight: 600, color: '#333' }}>{s.deger}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function GrupBaslik({ baslik, ikon }: { baslik: string; ikon: string }) {
  return (
    <div style={{ gridColumn: '1 / -1', display: 'flex', alignItems: 'center',
      gap: 8, marginTop: 8, paddingBottom: 6, borderBottom: '2px solid #e8e8e8' }}>
      <span style={{ fontSize: 18 }}>{ikon}</span>
      <span style={{ fontWeight: 700, fontSize: 14, color: '#444' }}>{baslik}</span>
    </div>
  );
}

export default function IsletmeDetay() {
  const { id: rawId } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const userStr2 = localStorage.getItem('user');
  const user2    = userStr2 ? JSON.parse(userStr2) : null;
  // :id literal gelirse (menüde parametre çözülmemişse) kullanıcının işletmesine yönlendir
  const id = rawId === ':id' ? String(user2?.isletme_id ?? '') : rawId;

  const sp = new URLSearchParams(window.location.search);
  const initYil = Number(sp.get('yil') || YIL);
  const initAy  = sp.get('ay') ? Number(sp.get('ay')) : (initYil === YIL ? AY : 12);
  const [yil, setYil] = useState(initYil);
  const [ay,  setAy]  = useState(initAy);

  const degistirYil = (yeniYil: number) => {
    setYil(yeniYil);
    setAy(yeniYil === YIL ? AY : 12);
  };

  const [isletme,    setIsletme]    = useState<any>(null);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [ozet,       setOzet]       = useState<Record<string, any>>({});
  const [yukleniyor, setYukleniyor] = useState(false);
  const [kiralikGoster, setKiralikGoster] = useState(false);

  const userStr = localStorage.getItem('user');
  const user    = userStr ? JSON.parse(userStr) : null;
  const isGM    = user?.rol && ['super_admin','gm_yonetici','gm_personel'].includes(user.rol);

  useEffect(() => {
    if (!id) return;
    fetch(`${API}/api/isletmeler/${id}`, { headers: hdr() })
      .then(r => r.ok ? r.json() : null)
      .then(setIsletme);
  }, [id]);

  useEffect(() => {
    if (isGM) tanimlarApi.isletmelerListesi(kiralikGoster).then(r => setIsletmeler(r.data));
  }, [kiralikGoster]);

  const fetchOzet = useCallback(async (isletmeId: string, y: number, a: number) => {
    const p = (u: string) => `${u}?yil=${y}&ay=${a}&isletme_id=${isletmeId}`;
    setYukleniyor(true);
    try {
      const reqs = await Promise.all([
        fetch(`${API}${p('/api/hayvancilik/buyukbas/ozet')}`, { headers: hdr() }),
        fetch(`${API}${p('/api/hayvancilik/kucukbas/ozet')}`, { headers: hdr() }),
        fetch(`${API}${p('/api/at/ozet')}`,                    { headers: hdr() }),
        fetch(`${API}${p('/api/aricilik/ozet')}`,             { headers: hdr() }),
        fetch(`${API}${p('/api/bitkisel/tarla/ozet')}`,       { headers: hdr() }),
        fetch(`${API}${p('/api/bitkisel/yem/ozet')}`,         { headers: hdr() }),
        fetch(`${API}${p('/api/bitkisel/bahce/ozet')}`,       { headers: hdr() }),
        fetch(`${API}${p('/api/varlik/ozet')}`,               { headers: hdr() }),
      ]);
      const [buyukbas, kucukbas, at, aricilik, tarla, yem, bahce, varlik] =
        await Promise.all(reqs.map(r => r.ok ? r.json() : {}));
      setOzet({ buyukbas, kucukbas, at, aricilik, tarla, yem, bahce, varlik });
    } catch { setOzet({}); }
    finally { setYukleniyor(false); }
  }, []);

  useEffect(() => {
    if (id) fetchOzet(id, yil, ay);
  }, [id, yil, ay, fetchOzet]);

  const kr = (path: string) => {
    const params = new URLSearchParams({ yil: String(yil), ay: String(ay), isletme: id! });
    return `${path}?${params.toString()}`;
  };

  const veriYok = (key: string) => {
    const d = ozet[key];
    if (!d) return true;
    return Object.values(d).every(v => !v || v === 0);
  };

  return (
    <div>
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button onClick={() => navigate('/ybs')} className="btn"
            style={{ padding: '4px 12px', fontSize: 12 }}>
            ← YBS
          </button>
          <h1>🏢 {isletme ? isletme.ad : '...'}</h1>
        </div>
        <p>
          {isletme && (
            <span style={{ color: '#777', fontSize: 13 }}>
              {isletme.tip} · {isletme.il}{isletme.ilce ? ' / ' + isletme.ilce : ''}
              {isletme.mudur ? ` · Müdür: ${isletme.mudur}` : ''}
            </span>
          )}
        </p>
      </div>

      {/* FİLTRE: İşletme → Yıl → Ay */}
      <div className="card" style={{ padding: '12px 16px', marginBottom: 16,
        display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
        {isGM && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <label style={{ fontSize: 13, color: '#555', fontWeight: 600 }}>İşletme</label>
              <select className="form-control" value={id} style={{ width: 210, fontSize: 13 }}
                onChange={e => navigate(`/isletme/${e.target.value}?yil=${yil}&ay=${ay}`)}>
                {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
              </select>
            </div>
            <label style={{ display:'flex', alignItems:'center', gap:4, fontSize:12, cursor:'pointer', color:'#888', whiteSpace:'nowrap' }}>
              <input type="checkbox" checked={kiralikGoster} onChange={e => setKiralikGoster(e.target.checked)} />
              Kiralıkları Göster
            </label>
          </>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <label style={{ fontSize: 13, color: '#555', fontWeight: 600 }}>Yıl</label>
          <input type="number" className="form-control" value={yil}
            onChange={e => degistirYil(Number(e.target.value))}
            style={{ width: 90, fontSize: 13 }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <label style={{ fontSize: 13, color: '#555', fontWeight: 600 }}>Ay</label>
          <select className="form-control" value={ay}
            onChange={e => setAy(Number(e.target.value))}
            style={{ width: 110, fontSize: 13 }}>
            {AYLAR.slice(1).map((a, i) => (
              <option key={i+1} value={i+1}>{a}</option>
            ))}
          </select>
        </div>
        <span style={{ fontSize: 13, color: '#888', marginLeft: 8 }}>
          {yil} / {AYLAR[ay]} özeti
        </span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>

        <GrupBaslik baslik="Hayvancılık" ikon="🐄" />

        <Kart baslik="Büyükbaş" ikon="🐄" renk="#1e8449" route={kr('/buyukbas')}
          yukleniyor={yukleniyor} veriYok={veriYok('buyukbas')}
          satirlar={[
            { etiket: 'Toplam Hayvan', deger: fmt(ozet.buyukbas?.toplam_hayvan, 'baş') },
            { etiket: 'Süt Üretimi',   deger: fmt(ozet.buyukbas?.toplam_sut_kg, 'kg') },
            { etiket: 'Buzağı Doğum',  deger: fmt(ozet.buyukbas?.toplam_buzagi, 'baş') },
          ]} />

        <Kart baslik="Küçükbaş" ikon="🐑" renk="#1a5276" route={kr('/kucukbas')}
          yukleniyor={yukleniyor} veriYok={veriYok('kucukbas')}
          satirlar={[
            { etiket: 'Toplam Hayvan', deger: fmt(ozet.kucukbas?.toplam_hayvan, 'baş') },
            { etiket: 'Ana Hayvan',    deger: fmt(ozet.kucukbas?.toplam_ana, 'baş') },
            { etiket: 'Süt Üretimi',   deger: fmt(ozet.kucukbas?.toplam_sut_kg, 'kg') },
          ]} />

        <Kart baslik="At Yetiştiriciliği" ikon="🐴" renk="#6c3483" route={kr('/at')}
          yukleniyor={yukleniyor} veriYok={veriYok('at')}
          satirlar={[
            { etiket: 'Kısrak', deger: fmt(ozet.at?.toplam_kisrak, 'baş') },
            { etiket: 'Aygır',  deger: fmt(ozet.at?.toplam_aygir, 'baş') },
            { etiket: 'Tay',    deger: fmt(ozet.at?.toplam_tay, 'baş') },
          ]} />

        <Kart baslik="Arıcılık" ikon="🐝" renk="#d4ac0d" route={kr('/aricilik')}
          yukleniyor={yukleniyor} veriYok={veriYok('aricilik')}
          satirlar={[
            { etiket: 'Kovan Sayısı', deger: fmt(ozet.aricilik?.toplam_kovan, 'kovan') },
            { etiket: 'Bal Üretimi',  deger: fmt(ozet.aricilik?.toplam_bal_kg, 'kg') },
          ]} />

        <GrupBaslik baslik="Bitkisel Üretim" ikon="🌾" />

        <Kart baslik="Tarla Bitkileri" ikon="🌾" renk="#7d6608" route={kr('/tarla')}
          yukleniyor={yukleniyor} veriYok={veriYok('tarla')}
          satirlar={[
            { etiket: 'Ekim Alanı', deger: fmt(ozet.tarla?.toplam_ekim_da, 'da') },
            { etiket: 'Üretim',     deger: fmt(ozet.tarla?.toplam_uretim_kg, 'kg') },
            { etiket: 'Tohum Ürt.', deger: fmt(ozet.tarla?.toplam_tohum_ton, 'ton') },
          ]} />

        <Kart baslik="Yem Bitkileri" ikon="🌿" renk="#27ae60" route={kr('/yem')}
          yukleniyor={yukleniyor} veriYok={veriYok('yem')}
          satirlar={[
            { etiket: 'Ekim Alanı', deger: fmt(ozet.yem?.toplam_alan_da, 'da') },
            { etiket: 'Üretim',     deger: fmt(ozet.yem?.toplam_uretim_kg, 'kg') },
          ]} />

        <Kart baslik="Bahçe Kültürleri" ikon="🌳" renk="#e67e22" route={kr('/bahce')}
          yukleniyor={yukleniyor} veriYok={veriYok('bahce')}
          satirlar={[
            { etiket: 'Ekim Alanı', deger: fmt(ozet.bahce?.toplam_alan_da, 'da') },
            { etiket: 'Üretim',     deger: fmt(ozet.bahce?.toplam_uretim_kg, 'kg') },
          ]} />

        <GrupBaslik baslik="Varlık Yönetimi" ikon="🏗️" />

        <Kart baslik="Arazi" ikon="🗺️" renk="#117a65" route={kr('/arazi')}
          yukleniyor={yukleniyor} veriYok={!ozet.varlik?.toplam_arazi_da}
          satirlar={[
            { etiket: 'Toplam Arazi',  deger: fmt(ozet.varlik?.toplam_arazi_da, 'da') },
            { etiket: 'Sulanan Arazi', deger: fmt(ozet.varlik?.sulanan_arazi_da, 'da') },
          ]} />

        <Kart baslik="Makine & Ekipman" ikon="🚜" renk="#1a5276" route={kr('/makine')}
          yukleniyor={yukleniyor} veriYok={!ozet.varlik?.traktor_adet}
          satirlar={[
            { etiket: 'Traktör',     deger: fmt(ozet.varlik?.traktor_adet, 'adet') },
            { etiket: 'İş Makinesi', deger: fmt(ozet.varlik?.is_makinesi_adet, 'adet') },
          ]} />

        <Kart baslik="Taşıt" ikon="🚗" renk="#6c3483" route={kr('/tasit')}
          yukleniyor={yukleniyor} veriYok={!ozet.varlik?.toplam_tasit}
          satirlar={[
            { etiket: 'Toplam Taşıt', deger: fmt(ozet.varlik?.toplam_tasit, 'adet') },
          ]} />

        <Kart baslik="Tesis & Altyapı" ikon="🏭" renk="#7d6608" route={kr('/tesis')}
          yukleniyor={yukleniyor} veriYok={!ozet.varlik?.silo_ton}
          satirlar={[
            { etiket: 'Silo Kapasitesi', deger: fmt(ozet.varlik?.silo_ton, 'ton') },
            { etiket: 'B.baş Barınağı',  deger: fmt(ozet.varlik?.buyukbas_barinagi_bas, 'baş') },
          ]} />

      </div>
    </div>
  );
}
